import {
    songSchema as Schema,
    ParseDbService,
    songTypeSchema,
    cdLinkSchema,
    thumbnailSchema,
    mediaSchema,
    artistSchema, albumSchema, fileSchema
} from '.'


import Parse from "parse";

function getAll({page, perPage}, search) {
    let query = new Parse.Query(ParseDbService.SongClassName)
        .skip((page - 1) * perPage)
        .limit(perPage)
        .withCount(true);

    query.include(Schema.album)
        .include(Schema.artist)
        .include(Schema.media)
        .include(Schema.file)
        .include(Schema.thumbnail)
        .include(Schema.link)
        .include(Schema.type);

    if (search !== undefined && search != null && search.length !== 0) {
        query.contains(Schema.title, search);
    }

    return query.find().then(items => {
        console.log(items)
        return {
            results: items.results.map(item => {

                let songs = {
                    parseItem: item,
                    title: item.get(Schema.title),
                    length: item.get(Schema.length),
                };

                let fileToAdd = item.get(Schema.file);

                songs.songFile = {
                    parseItem: fileToAdd,
                    id: fileToAdd.id,
                    file: fileToAdd.get(fileSchema.file),
                    name: fileToAdd.get(fileSchema.name),
                    size: fileToAdd.get(fileSchema.size),
                    length: fileToAdd.get(fileSchema.length)
                };

                let album = item.get(Schema.album);
                if (album != null)
                    songs.album = {
                        parseItem: album,
                        title: album.get(albumSchema.title),
                        tracks: album.get(albumSchema.tracks)
                    };

                let artist = item.get(Schema.artist);

                if (artist != null)
                    songs.artist = {
                        parseItem: artist,
                        name: artist.get(artistSchema.name)
                    };

                let media = item.get(Schema.media);

                if (media != null)
                    songs.media = {
                        parseItem: media,
                        title: media.get(mediaSchema.title),
                        mediaId: media.get(mediaSchema.mediaId)
                    };

                let thumbnail = item.get(Schema.thumbnail);

                if (thumbnail != null)
                    songs.thumbnail = {
                        parseItem: thumbnail,
                        name: thumbnail.get(thumbnailSchema.name),
                        thumbnail: thumbnail.get(thumbnailSchema.image)
                    };

                let cdLinks = item.get(Schema.link);

                if (cdLinks != null)
                    songs.cdLinks = cdLinks.map(link => {
                        return {
                            parseItem: link,
                            name: link.get(cdLinkSchema.name),
                            link: link.get(cdLinkSchema.link)
                        }
                    });

                let songType = item.get(Schema.type);

                if (songType != null)
                    songs.songType = {
                        parseItem: songType,
                        name: songType.get(songTypeSchema.name)
                    };

                return songs;
            }),
            count: items.count
        }
    });
}


function add({title, length, songFile, album, artist, media, thumbnail, cdLinks, songType}) {
    let Song = Parse.Object.extend(ParseDbService.SongClassName, null, null);
    let song = new Song();
    song.set(Schema.title, title)
        .set(Schema.length, length)
        .set(Schema.file, songFile.parseItem);

    if (album != null)
        song.set(Schema.album, album.parseItem);

    if (artist != null)
        song.set(Schema.artist, artist.parseItem);
    if (media != null)
        song.set(Schema.media, media.parseItem);
    if (thumbnail != null)
        song.set(Schema.thumbnail, thumbnail.parseItem);
    if (cdLinks != null && cdLinks.length !== 0)
        song.set(Schema.link, cdLinks.map(x => x.parseItem));
    if (songType != null)
        song.set(Schema.type, songType.parseItem);

    return song.save()
}


function edit({parseItem, title, length, songFile, album, artist, media, thumbnail, cdLinks, songType}) {
    let editableObj = parseItem;
    editableObj.set(Schema.title, title);
    editableObj.set(Schema.length, length);
    editableObj.set(Schema.file, songFile.parseItem);
    editableObj.set(Schema.album, album != null ? album.parseItem : null);
    editableObj.set(Schema.artist, artist != null ? artist.parseItem: null);
    editableObj.set(Schema.media, media != null ? media.parseItem: null);
    editableObj.set(Schema.thumbnail, thumbnail != null ? thumbnail.parseItem: null);
    editableObj.set(Schema.link, cdLinks != null ? cdLinks.map(x => x.parseItem): null);
    editableObj.set(Schema.type, songType != null ? songType.parseItem : null);
    return editableObj.save()
}


export const SongService = {
    getAll,
    add,
    edit
};